// extracted by mini-css-extract-plugin
export var border = "_k-7";
export var brand = "_k-r";
export var button = "_k-j";
export var center = "_k-9";
export var centered = "_k-5";
export var closeButton = "_k-b";
export var disabledWrapper = "_k-k";
export var error = "_k-n";
export var extraLarge = "_k-4";
export var extraSmall = "_k-1";
export var fill = "_k-g";
export var footer = "_k-f";
export var footerAction = "_k-h";
export var footerButtons = "_k-i";
export var header = "_k-6";
export var icon = "_k-m";
export var info = "_k-q";
export var inline = "_k-8";
export var large = "_k-3";
export var main = "_k-c";
export var modal = "_k-0";
export var neutral = "_k-s";
export var noPadding = "_k-e";
export var none = "_k-t";
export var scrollable = "_k-d";
export var small = "_k-2";
export var success = "_k-p";
export var tight = "_k-l";
export var titleIcon = "_k-a";
export var warn = "_k-o";